<template>
  <div class="my-info">
    <div class="my-info-container mt-5">
      <b-row class="c-card-section">
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'info' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 100%" src="images/design/myinfo.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("myinfo") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'obligations' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img
                  style="width: 120%"
                  src="images/design/development.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("obligations") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'Request' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 100%" src="images/design/request.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("RequestInfo") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'inspector' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 100%" src="images/design/inspector.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("Inspector") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'maxsusguvohnoma' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img
                  style="width: 50%"
                  src="images/design/certificate.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("MaxsusGuvohnoma") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'controlfunction' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 100%" src="images/design/cfunction.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("ControlFunction") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'mandatoryrequirement' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img
                  style="width: 100%"
                  src="images/design/requirement.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("MandRequirement") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'complaint' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 100%" src="images/design/complaint.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("Complaint") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'dishonestrequest' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width: 70%" src="images/design/dishonest.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("DishonestRequest") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'publicreception' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img
                  style="width: 100%"
                  src="images/design/publicreception.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("PublicReception") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'inspectionbookofcontractor' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img
                  style="width: 65%"
                  src="images/design/inpectionbook.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("inspectionbookAll") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor:pointer"
            @click="$router.push({ name: 'videolesson' })"
          >
            <b-col>
              <div class="mt-auto d-block">
                <b-img style="width:80%" src="images/design/video_lesson.svg" />
              </div>
              <div style="font-size: 16px;text-align: center; margin-top: 10px">
                {{ $t("videolesson") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'corruptionreport' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img
                  style="width: 80%"
                  src="images/design/corruption.svg"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("CorruptionReport") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'mahallaportal' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img style="width: 80%" src="images/design/chat.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("MahallaPortal") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'rating' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img style="width: 80%" src="images/design/rating.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("Rating") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'xabarnoma' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img style="width: 80%" src="images/design/xabarnoma.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("Xabarnoma") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'muloqotlist' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img style="width: 80%" src="images/design/working.svg" />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("MuloqotList") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
        >
          <b-row
            class="w-100"
            style="cursor: pointer"
            @click="$router.push({ name: 'BiznesHimoya' })"
          >
            <b-col>
              <div class="mt-auto d-block text-center">
                <b-img
                  style="height: 130px; width: auto; max-width: 100%"
                  src="images/biznes-himoya-badge.png"
                />
              </div>
              <div
                style="font-size: 16px; text-align: center; margin-top: 10px"
              >
                {{ $t("BHTitle") }}
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="4"
          class="d-flex align-items-center c-my-col"
          v-if="!IsEmployee"
        >
          <a
            style="color:black;text-decoration: none"
            href="https://t.me/tekshiruvinfo_bot"
            target="_blank"
          >
            <b-row class="w-100" style="cursor:pointer">
              <b-col>
                <div class="mt-auto d-block">
                  <b-img
                    style="width:90%"
                    src="images/design/telegram_bot.svg"
                  />
                </div>
                <div
                  style="font-size: 16px;text-align: center; margin-top: 10px"
                >
                  {{ $t("Telegram_Bot") }}
                </div>
              </b-col>
            </b-row>
          </a>
        </b-col>
      </b-row>
      <!-- </b-row> -->
      <b-modal
        v-model="contractorModal"
        hide-footer
        hide-header
        no-close-on-backdrop
      >
        <div
          style="
            text-align: right;
            margin-right: 10px;
            margin-top: -5px;
            margin-bottom: 5px;
            border-bottom: 1px solid lightgray;
          "
        >
          <span
            @click="contractorModal = false"
            style="cursor: pointer; font-size: 30px"
          >
            &times;
          </span>
        </div>
        <div>
          <custom-select
            :options="ContractorList"
            v-model="filter.contractorId"
            :label="$t('contractor')"
            :valueid="'tin'"
            @input="selectContractor()"
          ></custom-select>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BImg, BModal, BButton } from "bootstrap-vue";
import AccountService from "../../services/account.service";
import customSelect from "../../components/elements/customSelect.vue";
import customButton from "../../components/elements/customButton.vue";
export default {
  data() {
    return {
      contractorModal: false,
      ContractorList: [],
      filter: {
        contractorId: 0,
      },
      username: "",
    };
  },
  created() {
    this.userName = JSON.parse(localStorage.getItem("user_info"));
    if (!this.IsEmployee && !this.ContractorId) {
      this.contractorModal = true;
      AccountService.GetContractorsList().then((res) => {
        this.ContractorList = res.data;
      });
    }
  },
  components: {
    BRow,
    BCol,
    BImg,
    BModal,
    customSelect,
    customButton,
    BButton,
  },
  computed: {
    ContractorId() {
      return JSON.parse(localStorage.getItem("user_info")).contractorId;
    },
    IsEmployee() {
      return !!JSON.parse(localStorage.getItem("user_info")).isEmployee;
    },
    IsTeacher() {
      return JSON.parse(localStorage.getItem("user_info")).IsTeacher;
    },
    IsHeadOfSchoolGrade() {
      return JSON.parse(localStorage.getItem("user_info")).IsHeadOfSchoolGrade;
    },
  },
  methods: {
    GoToInspectionBook() {
      if (this.ContractorId === 1) {
        this.$router.push({ name: "inspectionbookcombined" });
      } else {
        this.$router.push({ name: "inspectionbookofcontractor" });
      }
    },
    selectContractor() {
      if (!!this.filter.contractorId) {
        AccountService.SelectContractor(this.filter.contractorId)
          .then((res) => {
            localStorage.setItem("user_info", JSON.stringify(res.data));
            this.contractorModal = false;
          })
          .catch((error) => {
            this.makeToast(error.response.data, "error");
          });
      }
    },
  },
};
</script>

<style>
@media screen and (min-width: 992px) {
  .c-card-section .c-my-col .row .col {
    height: 200px !important;
  }
}
@media screen and (max-width: 700px) {
  .my-info-container {
    width: 100% !important;
  }
  .c-card-section .c-my-col .row .col {
    height: 160px !important;
  }
}
@media screen and (max-width: 991px) and (min-width: 701px) {
  .my-info-container {
    width: 100% !important;
  }
  .c-title {
    font-size: 24px !important;
  }
  .c-card-section .c-my-col .row .col {
    height: 260px !important;
  }
}
@media screen and (max-width: 576px) {
  .my-info-container {
    width: 100% !important;
  }
  .c-title {
    font-size: 24px !important;
  }
  .c-card-section .c-my-col .row .col img {
    height: 120px;
  }
}
</style>
